/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockVideo as VideoBlockModel } from '@staffino/model';
import { Video } from '@staffino/primitive-controls';

type Props = {
  block: VideoBlockModel;
};
const VideoBlock = ({ block }: Props) => (
  <Video height={`${block.size}px`} source={{ uri: block.url }} />
);

export default VideoBlock;
